<template>
	<div class="navmb">
		<div class="flex flexa">
			<el-icon class="astyle bgshadow" color="#FF6A00" size="20" @click="$router.push({
				name: 'tech/list',
				params: {
					type: 2
				}
			})">
				<Back />
			</el-icon> &nbsp; &nbsp;
			<span class="">新建技术服务请求</span>
		</div>
	</div>
	<ul class="ul1 ul-stepb1">
		<li :class="step >= 1 ? 'act' : ''">
			<span class="num">1</span>
			<p>问题描述/严重性</p>
			<div class="line"></div>
		</li>
		<li :class="step >= 2 ? 'act' : ''">
			<span class="num">2</span>
			<p>智能推荐解决方案</p>
			<div class="line"></div>
		</li>
		<li :class="step >= 3 ? 'act' : ''">
			<span class="num">3</span>
			<p>详细资料</p>
			<div class="line"></div>
		</li>
		<li :class="step >= 4 ? 'act' : ''">
			<span class="num">4</span>
			<p>联系方式</p>
		</li>
	</ul>
	<div v-if="step == 1" v-loading="loading" class="bgf padd20">
		<el-form :model="baseInfo.form" ref="submitForm_baseInfo" label-width="auto" :rules="baseInfo.rule"
			scroll-to-error :scroll-into-view-options="{ block: 'center', inline: 'nearest' }">
			<p class="col24 font18 fontw5 marb24">客户服务号选择</p>
			<ul class="ul-form marb30 clearfix">
				<li style="display: block">&nbsp;</li>
				<li>
					<div class="con">
						<div class="ty"><em>*</em>客户服务号</div>
						<div class="right">
							<div class="w255">
								<el-form-item prop="csi">
									<el-select size="large" v-model="baseInfo.form.csi" placeholder="请先选择客户服务号选择"
										clearable @change="csiChange" @clear="csiClear">
										<el-option v-for="(item, index) in csiList" :key="index"
											:label="item.csiNumber + '（' + item.companyName + '）'" :value="item.id">
										</el-option>
									</el-select>
								</el-form-item>
							</div>
							<div class="tips">
								温馨提示：选择服务号支持的服务模块才能成功提交相关的技术服务请求。
							</div>
						</div>
					</div>
				</li>
			</ul>
			<template v-if="baseInfo.form.csi">
				<p class="col24 font18 fontw5 marb24">问题发生在什么地方？</p>

				<ul class="ul-form clearfix">
					<li>
						<div class="con">
							<div class="ty"><em>*</em>客户名称</div>
							<div class="right w255">
								<el-form-item prop="accountName">
									<el-input
										v-model="baseInfo.form.accountName"
										:placeholder="isSpecificScenario ? '请输入客户名称' : '请填写全名'"
										:disabled="!isSpecificScenario"
										class="ww100"
										size="large"
									></el-input>
								</el-form-item>
							</div>
						</div>
					</li>
					<li>
						<div class="con">
							<div class="ty"><em>*</em>环境用途</div>
							<div class="right w255">
								<el-form-item prop="environmentalUse">
									<el-select size="large" v-model="baseInfo.form.environmentalUse" placeholder="请选择" @change="environmentalUseChange">
										<el-option v-for="item in environmentalUseL" :key="item.name" :label="item.name"
											:value="item.value" />
									</el-select>
								</el-form-item>
							</div>
						</div>
					</li>
				</ul>
				<ul class="ul-form clearfix">
					<li v-if="baseInfo.form.environmentalUse == 1">
						<div class="con">
							<div class="ty"><em>*</em>是否影响业务</div>
							<div class="right w255">
								<el-form-item prop="isEffect">
									<el-select size="large" v-model="baseInfo.form.isEffect" placeholder="请选择">
										<el-option label="有影响" :value="1" />
										<el-option label="无影响" :value="2" />
									</el-select>
								</el-form-item>
							</div>
						</div>
					</li>
					<li v-if="baseInfo.form.environmentalUse==1&&baseInfo.form.isEffect==1">
						<div class="con">
							<div class="ty"><em>*</em>对业务影响开始时间</div>
							<div class="right w255 flex flexa">
								<el-form-item prop="occurrenceTime">
									<el-date-picker @change="handleTimeChange" type="datetime" class="ww100" size="large" format="YYYY-MM-DD HH:mm" value-format="YYYY-MM-DD HH:mm"
										v-model="baseInfo.form.occurrenceTime" placeholder="对业务影响开始时间"></el-date-picker>
								</el-form-item>
							</div>
						</div>
					</li>
					<li v-if="baseInfo.form.environmentalUse==1&&baseInfo.form.isEffect==1">
						<div class="con">
							<div class="ty">对业务影响结束时间</div>
							<div class="right flex flexa">
								<el-form-item>
									<el-date-picker type="datetime" @change="handleTimeChange" class="ww100" size="large" format="YYYY-MM-DD HH:mm"
										value-format="YYYY-MM-DD HH:mm" v-model="baseInfo.form.restoreTime"
										placeholder="对业务影响结束时间"></el-date-picker>
										<div v-if="baseInfo.form.isEffect==1" class="ty" style="margin-left: 10px">(故障时长:{{ baseInfo.form.durationMalfunction||"- -" }}分钟)</div>
								</el-form-item>
							</div>
						</div>
						<p v-if="baseInfo.form.environmentalUse==1&&baseInfo.form.isEffect==1" class="new_tips">温馨提示：如果当前业务未恢复，请故障恢复后及时在服务请求右侧更新故障恢复时间</p>
					</li>
				</ul>
				<ul class="ul-form clearfix">
					<li>
						<div class="con">
							<div class="ty"><em>*</em>硬件平台</div>
							<div class="right w255">
								<el-form-item prop="hardwarePlatform">
									<el-select size="large" v-model="baseInfo.form.hardwarePlatform" placeholder="请选择">
										<el-option v-for="item in hardwarePlatform" :key="item.dictValue"
											:label="item.dictLabel" :value="item.dictValue" />
									</el-select>
								</el-form-item>
							</div>
						</div>
					</li>
					<li>
						<div class="con">
							<div class="ty"><em>*</em>操作系统版本</div>
							<div class="right w255">
								<el-form-item prop="operatingSystemVersionId">
									<el-cascader v-model="baseInfo.form.operatingSystemVersionId" size="large"
										class="w100" :props="system.props" :options="system.options"
										placeholder="请选择" />
								</el-form-item>
							</div>
						</div>
					</li>
					<div class="ww100"></div>
					<li>
						<div class="con">
							<div class="ty"><em>*</em>操作系统语言</div>
							<div class="right w255">
								<el-form-item prop="operatingSystemLanguage">
									<el-select size="large" v-model="baseInfo.form.operatingSystemLanguage"
										placeholder="请选择">
										<el-option v-for="item in language" :key="item.dictValue"
											:label="item.dictLabel" :value="item.dictValue" />
									</el-select>
								</el-form-item>
							</div>
						</div>
					</li>
					<li>
						<div class="con">
							<div class="ty"><em>*</em>产品名称</div>
							<div class="right w255">
								<el-form-item prop="productId">
									<el-select size="large" v-model="baseInfo.form.productId" value-key="id"
										placeholder="请选择" @change="$event => {
				baseInfo.form.productName = $event.productName
				vselect_module($event.id);
				vselect_version($event.id)
			}">
										<el-option v-for="item in vselect.product.options" :key="item.id"
											:label="item.productName" :value="item" />
									</el-select>
								</el-form-item>
							</div>
						</div>
					</li>
					<div class="ww100"></div>
					<li>
						<div class="con">
							<div class="ty"><em>*</em>产品版本</div>
							<div class="right w255">
								<el-form-item prop="versionId">
									<el-select v-model="baseInfo.form.versionId" size="large" value-key="id"
										placeholder="请选择"
										@change="$event => baseInfo.form.versionName = $event.versionName">
										<el-option v-for="item in versionMapList" :key="item.id"
											:label="item.versionName" :value="item">
										</el-option>
									</el-select>
								</el-form-item>
							</div>
						</div>
					</li>
					<li>
						<div class="con">
							<div class="ty"><em>*</em>问题类型</div>
							<div class="right w255">
								<el-form-item prop="productModuleId">
									<!-- <el-select v-model="baseInfo.form.productModuleId" value-key="id" size="large"
										placeholder="请选择" @change="$event => {
					baseInfo.form.moduleName = $event.moduleName;
					searchQuestionTemplate({ productId: baseInfo.form.productId.id, productModuleId: $event.id })
				}">
										<el-option v-for="item in moduleMapList" :key="item.id" :label="item.moduleName"
											:value="item">
										</el-option>
									</el-select> -->
									<el-cascader v-model="baseInfo.form.productModuleId" size="large" class="w100"
										:props="{
				checkStrictly: false,
				emitPath: true,
				value: 'id',
				label: 'moduleName',
				children: 'moduleListDtos'
			}" :options="moduleMapList" placeholder="请选择" @change="productModuleIdChange">
									</el-cascader>
								</el-form-item>
							</div>
						</div>
					</li>
					<div class="ww100"></div>
					<li>
						<div class="con">
							<div class="ty"><em>*</em>部署方式</div>
							<div class="right w255">
								<el-form-item prop="deploymentWay">
									<el-select size="large" v-model="baseInfo.form.deploymentWay" placeholder="请选择">
										<el-option v-for="item in deploy" :key="item.dictValue" :label="item.dictLabel"
											:value="item.dictValue" />
									</el-select>
								</el-form-item>
							</div>
						</div>
					</li>
					<li>
						<div style="margin-left:20px" class="con">
							<div class="ty"><em>*</em>是否海量数据库一体机？</div>
							<div class="right">
								<div class="m-radsb1">
									<el-form-item prop="oneMachine">
										<el-radio-group v-model="baseInfo.form.oneMachine">
											<el-radio :value="1">是</el-radio>
											<el-radio :value="2">否</el-radio>
										</el-radio-group>
									</el-form-item>
								</div>
							</div>
						</div>
					</li>
					<br />
					<li>
						<div class="con">
							<el-popover placement="top-start" trigger="hover" :width="500">
								<template #reference>
									<div class="flex flexa padb30 point ty" style="justify-content: flex-end">
										<p class="col8f font14">
											<span class="colred">*</span> &nbsp;问题严重性
										</p>

										<img :src="utils.loadImg('i.png')" width="16" alt="" srcset="" />
									</div>
								</template>
								<ul class="col23 font10 lh14 nowrap">
									<li>
										U1 -
										服务完全丢失。问题或产品缺陷会导致正式版环境中的服务完全丢失或无法继续正常工作。
									</li>
									&nbsp;
									<li>
										U2 -
										服务严重丢失。没有可行解决方法。但是，操作可以在受限方式下继续执行。
									</li>
									&nbsp;
									<li>
										U3 -
										服务少量丢失。造成了不便的影响，可能需要解决方法来恢复功能。
									</li>
									&nbsp;
									<li>U4 - 未丢失服务。轻微错误，不妨碍操作。</li>
								</ul>
							</el-popover>
							<div class="right">
								<el-form-item prop="u">
									<div class="m-radsb1">
										<el-radio-group v-model="baseInfo.form.u">
											<el-radio :value="1">U1-服务完全丢失</el-radio>
											<el-radio :value="2">U2-服务严重丢失</el-radio>
											<el-radio :value="3">U3-服务少量丢失</el-radio>
											<el-radio :value="4">U4-未丢失服务</el-radio>
										</el-radio-group>

									</div>
								</el-form-item>
								<p class="new_tips">非工作时段提交的问题工单，我们将于下一工作日优先为您跟进处理。若遇紧急业务阻碍或需即时技术支持，请直接拨打400服务热线（电话：4000123005），我们将为您提供加急响应服务。</p>
							</div>
						</div>
					</li>
					<li>
						<div class="con">
							<div class="ty"><em>*</em>紧急程度</div>
							<div class="right">
								<el-form-item prop="urgencyCode">
									<el-radio-group v-model="baseInfo.form.urgencyCode">
										<el-radio v-for="item in urgencyDict" :key="item.dictValue"
											:value="item.dictValue">{{ item.dictLabel }}</el-radio>
									</el-radio-group>
								</el-form-item>
							</div>
						</div>
					</li>
				</ul>
				<p class="col24 font18 fontw5">问题描述</p>
				<div class="flex">
					<div class="flex5">
						<ul class="sylform labw120 padt30 padb30">
							<li>
								<label for=""><em>*</em>问题概要</label>
								<el-form-item prop="problemProfile">
									<el-input v-model="baseInfo.form.problemProfile" placeholder="请输入问题的概要" class="w700"
										size="large"></el-input>
								</el-form-item>
							</li>
							<li class="li1">
								<label for=""><em>*</em>问题描述</label>
								<div class="imgli1">
									<div class="font14 w620" style="box-sizing: border-box; z-index: 500;">
										<kindeditor :uploadParams="{
				type: 3,
			}" :content="baseInfo.form.problemDescription" width="700px" height="400px"
											@base64Html="base64Flie($event, 'baseInfo', 'problemDescription', 'form')"
											id="kind2"
											@on-content-change="onContentChange($event, 'baseInfo', 'problemDescription', 'form')">
										</kindeditor>
										<!-- <Toolbar style="border-bottom: 1px solid #dfe2e8" :editor="editorRef"
											mode="default" />
										<Editor class="w100" style="height: 400px; overflow-y: hidden"
											v-model="baseInfo.form.problemDescription" :defaultConfig="editorConfig"
											mode="default" @onCreated="$event => editorRef = $event" /> -->
										<el-form-item prop="problemDescription">
										</el-form-item>
									</div>
								</div>
							</li>
							<li class="li1" style="margin-top:-20px">
								<label for="">错误代码</label>
								<div>
									<el-form-item prop="errorCode">
										<!-- maxlength="10"  -->
										<el-input maxlength="300" v-model="baseInfo.form.errorCode" type="textarea"
											:rows="2" placeholder="请输入程序中错误代码" class="w700" size="large"></el-input>
									</el-form-item>
									<br />
									<p style="margin-top:-20px" class="col8f font14">请输入数据库、程序中报错的错误代码</p>
								</div>
							</li>
						</ul>
						<p class="col24 font18 fontw5 marb24">团队内工单查阅权限</p>
						<ul class="ul-form clearfix sty1">
							<li>
								<div class="con">
									<div class="ty"><em>*</em>是否全部公开</div>
									<div class="right">
										<div class="m-radsb1">
											<el-form-item prop="isOpen">
												<el-radio-group v-model="baseInfo.form.isOpen">
													<el-radio :value="1">是</el-radio>
													<el-radio :value="2">否</el-radio>
												</el-radio-group>
											</el-form-item>
										</div>
									</div>
								</div>
							</li>
							<li v-if="baseInfo.form.isOpen == 2">
								<div class="con">
									<div class="ty"><em>*</em> 公开的团队部门</div>
									<div class="right">
										<el-form-item prop="departmentId">
											<el-select v-model="baseInfo.form.departmentId" size="large" multiple
												collapse-tags :max-collapse-tags="2" collapse-tags-tooltip
												placeholder="请选择" style="width: 340px">
												<el-option
													v-for="item in vselect.team.map_options.get(baseInfo.form.csi)"
													:key="item.id" :label="item.departmentTitle" :value="item.id" />
											</el-select>
										</el-form-item>
									</div>
								</div>
							</li>
						</ul>
					</div>
					<!-- 暂时改下 -->
					<!-- <el-divider direction="vertical" style="height: 260px; margin-top: 30px"></el-divider> -->
					<!-- <div class="flex3 padt40" style="padding-left: 8%; overflow: hidden">
						<div class="flex">
							<el-popover placement="top-start" trigger="hover" :width="500">
								<template #reference>
									<div class="flex flexa padb30 point">
										<p class="col8f font14">
											<span class="colred">*</span> &nbsp;问题严重性
										</p>

										<img :src="utils.loadImg('i.png')" width="16" alt="" srcset="" />
									</div>
								</template>
								<ul class="col23 font10 lh14 nowrap">
									<li>
										U1 -
										服务完全丢失。问题或产品缺陷会导致正式版环境中的服务完全丢失或无法继续正常工作。
									</li>
									&nbsp;
									<li>
										U2 -
										服务严重丢失。没有可行解决方法。但是，操作可以在受限方式下继续执行。
									</li>
									&nbsp;
									<li>
										U3 -
										服务少量丢失。造成了不便的影响，可能需要解决方法来恢复功能。
									</li>
									&nbsp;
									<li>U4 - 未丢失服务。轻微错误，不妨碍操作。</li>
								</ul>
							</el-popover>
						</div>
						<el-form-item prop="u">
							<el-radio-group v-model="baseInfo.form.u" class="v-radio-group">
								<el-radio :value="1" class="padb20 col0d">U1-服务完全丢失</el-radio>
								<br />
								<el-radio :value="2" class="padb20 col0d">U2-服务严重丢失</el-radio>
								<br />
								<el-radio :value="3" class="padb20 col0d">U3-服务少量丢失</el-radio>
								<br />
								<el-radio :value="4" class="padb20 col0d">U4-未丢失服务</el-radio>
							</el-radio-group>
						</el-form-item>
					</div> -->
				</div>
			</template>
		</el-form>

		<ul class="sylform labw120" v-if="baseInfo.form.csi">
			<li class="padt20">
				<label for=""></label>
				<div>
					<el-button class="w90" size="large" type="primary" :loading="checkLoading"
						@click="submitBaseStep()">下一步</el-button>
					<el-button class="w68" size="large" @click="celall">取消</el-button>
				</div>
			</li>
		</ul>
	</div>

	<div v-if="step == 2" v-loading="knowDoc.loading" class="bgf padd20 padt30">
		<p class="font19 padb30">问题类型：{{ computed_moduleText }}</p>
		<p class="font16 bl-tipb1">根据您的问题描述，我们找到以下文档供参考</p>
		<div v-if="knowDoc.list.length > 0">
			<ul class="padb10 padt20">
				<li v-for="(item, index) in knowDoc.list" :key="index" class="padb14">
					<el-link v-html="item.docTitle" :href="'#/knowledgeInfo/' + item.id" target="_blank"></el-link>
				</li>
			</ul>
			<div class="h20"></div>
			<el-pagination v-model:currentPage="knowDoc.param.pageNumber" v-model:page-size="knowDoc.param.pageSize"
				@update:page-size="getknowDocList" @update:current-page="getknowDocList" :page-sizes="[10, 20, 30, 50]"
				layout=" prev, pager, next, sizes, jumper" :total="knowDoc.total">
			</el-pagination>
		</div>

		<div v-else class="inbl padl40">
			<el-empty description="暂无相关文档"></el-empty>
		</div>

		<div class="padt40 padb20">
			<el-button class="w90" @click="step = 1" size="large">上一步</el-button>
			<el-button class="w90" type="primary" @click="step = 3; Object.assign(baseInfo.form, {
				mainContact: userInfo.username,
				mainMobile: userInfo.mobile,
				mainEmail: userInfo.email,
			})" size="large">下一步</el-button>
			<el-button class="w68" @click="celall" size="large">取消</el-button>
		</div>
	</div>

	<div v-if="step == 3" class="bgf padd20">
		<p class="col24 font16 padb10">问题类型：{{ computed_moduleText }}</p>
		<el-form :model="baseInfo.form" ref="submitForm_Attachment" label-width="auto" :rules="baseInfo.rule">
			<ul class="sylform">
				<li class="li1">
					<label for="" class="wauto2">问题附件</label>
					<div>
						<el-form-item prop="attachmentPath">
							<ul class="ulfile padb10">
								<li v-for="(item, index) in fileList.attachmentPath" :key="index" class="">
									<span class="col63">{{ item.name }}</span>
									<span @click="() => {
				fileList.attachmentPath.splice(index, 1);
				baseInfo.form['attachmentPath'] = files.map(item => item.img).filter(item => item).join(',')
			}" class="colred point">删除</span>
								</li>
							</ul>
						</el-form-item>

						<div class="positionr inbl">
							<el-upload v-model:file-list="fileList.attachmentPath"
								:ref="el => fileList['instance_attachmentPath'] = el"
								:headers="{ token: $store.state.token }" :data="{
				type: 3
			}" action="/api/user/upload/ossUploadList" class="upload-demo" multiple :limit="5" :show-file-list="false"
								name="multipartFile" :on-success="(resp, file, files) => {
				if (resp.status == 200) {
					file.img = utils.Decrypt(resp.data).path;
					baseInfo.form['attachmentPath'] = files.map(item => item.img).filter(item => item).join(',')
				}
			}">
								<el-button type="primary" size="large">添加附件</el-button>
							</el-upload>
						</div>
						<p class="col8f font12 padt4">
							支持.png、.jpg、.jpeg、.txt、.rar、.doc、.xls、.xlsx、.zip格式，最大不超过50M
						</p>
					</div>
				</li>
				<li class="li1">
					<label for="" class="wauto2">附件注释</label>
					<el-form-item prop="attachmentDescription">
						<el-input v-model="baseInfo.form.attachmentDescription" type="textarea" :rows="6"
							placeholder="请输入添加附件的注释" class="w515" size="large"></el-input>
					</el-form-item>
				</li>
				<li class="li1 padt40">
					<label for="" style="opacity: 0" class="wauto2 colf">附件注释</label>
					<div class="padb20">
						<el-button class="w90" @click="step = 2" size="large">上一步</el-button>
						<el-button class="w90" type="primary" @click="submitAttachmentStep" size="large">下一步</el-button>
						<el-button class="w68" @click="celall" size="large">取消</el-button>
					</div>
				</li>
			</ul>
		</el-form>
	</div>

	<div v-if="step == 4" class="bgf padd20">
		<p class="col24 font16 padb30">请选择或新建服务请求联系人</p>
		<el-form ref="ruleForm" :model="baseInfo.form" :rules="baseInfo.rule" hide-required-asterisk
			class="demo-ruleForm" label-width="117px">
			<el-form-item prop="vs_conmode">
				<template #label>
					<label for="" class="font12 col8f padr14">选择联系人<em class="colred">*</em></label>
				</template>
				<el-radio-group v-model="baseInfo.form.vs_conmode">
					<el-radio :value="1">常用联系人选择</el-radio>
					<el-radio :value="2">新联系人</el-radio>
				</el-radio-group>
			</el-form-item>
			<el-form-item prop="vs_conid" v-if="baseInfo.form.vs_conmode == 1">
				<template #label>
					<label for="" class="font12 col8f padr14">常用联系人选择<em class="colred">*</em></label>
				</template>
				<el-select size="large" class="w240" filterable remote :remote-method="remoteMethod"
					v-model="baseInfo.form.vs_conid" placeholder="请选择" value-key="id" @change="$event => {
				baseInfo.form.mainContact = $event.username;
				baseInfo.form.mainMobile = $event.mobile;
				baseInfo.form.mainEmail = $event.email;
			}">
					<el-option v-for="(item, index) in vselect.userContacts.options" :label="item.username"
						:value="item" :key="index"></el-option>
				</el-select>
			</el-form-item>

			<el-form-item prop="mainContact">
				<template #label>
					<label for="" class="font12 col8f padr14">联系人姓名<em class="colred">*</em></label>
				</template>
				<el-input v-model="baseInfo.form.mainContact" placeholder="请输入联系人姓名" class="w240"
					size="large"></el-input>
			</el-form-item>
			<el-form-item prop="mainMobile">
				<template #label>
					<label for="" class="font12 col8f padr14">手机号<em class="colred">*</em></label>
				</template>
				<el-input v-model="baseInfo.form.mainMobile" placeholder="请输入手机号" class="w240" size="large"></el-input>
			</el-form-item>

			<el-form-item prop="mainEmail">
				<template #label>
					<label for="" class="font12 col8f padr14">邮箱号<em class="colred">*</em></label>
				</template>
				<el-input v-model="baseInfo.form.mainEmail" placeholder="请输入邮箱号" class="w240" size="large"></el-input>
				<!-- <el-checkbox-group v-model="list">
					<el-checkbox
                        :disabled="item.readonly??false"
                        :value="item.value"
                        :label="item.label"
                    />
				</el-checkbox-group> -->
			</el-form-item>

			<el-form-item prop="mode">
				<template #label>
					<label for="" class="font12 col8f padr14">首选联系方式<em class="colred">*</em></label>
				</template>
				<el-radio-group v-model="baseInfo.form.mode">
					<el-radio :value="1" label="电子邮件" />
					<el-radio :value="2" label="电话" />
				</el-radio-group>
			</el-form-item>
			<template v-if="baseInfo.form.u == 1">
				<p class="col24 font16 padb30">
					添加备用联系人联系方式 &nbsp;
					<span class="colred font10">注：由于您的工单等级是U1严重需要添加备用联系人</span>
				</p>

				<el-form-item prop="vs_sp_conmode">
					<template #label>
						<label for="" class="font12 col8f padr14">选择联系人<em class="colred">*</em></label>
					</template>
					<el-radio-group v-model="baseInfo.form.vs_sp_conmode">
						<el-radio :value="1">常用联系人选择</el-radio>
						<el-radio :value="2">新联系人</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item prop="vs_sp_conid" v-if="baseInfo.form.vs_sp_conmode == 1">
					<template #label>
						<label for="" class="font12 col8f padr14">常用联系人选择<em class="colred">*</em></label>
					</template>
					<el-select size="large" filterable remote :remote-method="remoteMethods" class="w240" value-key="id"
						v-model="baseInfo.form.vs_sp_conid" placeholder="请选择" @change="$event => {
				baseInfo.form.standbyContact = $event.username;
				baseInfo.form.standbyMobile = $event.mobile;
				baseInfo.form.standbyEmail = $event.email;
			}">
						<el-option v-for="(item, index) in vselect.userContacts.optionss" :label="item.username"
							:value="item" :key="index"></el-option>
					</el-select>
				</el-form-item>

				<el-form-item prop="standbyContact">
					<template #label>
						<label for="" class="font12 col8f padr14">联系人姓名<em class="colred">*</em></label>
					</template>
					<el-input v-model="baseInfo.form.standbyContact" placeholder="请输入联系人姓名" class="w240"
						size="large"></el-input>
					<!-- <el-input v-model="param.standbyContact" placeholder="请输入主要联系人" class="w240" size="large" ></el-input> -->
				</el-form-item>

				<el-form-item prop="standbyMobile">
					<template #label>
						<label for="" class="font12 col8f padr14">手机号<em class="colred">*</em></label>
					</template>
					<el-input v-model="baseInfo.form.standbyMobile" placeholder="请输入手机号" class="w240"
						size="large"></el-input>
					<!-- <el-input v-model="param.mainContact" placeholder="请输入主要联系人" class="w240" size="large" ></el-input> -->
				</el-form-item>

				<el-form-item prop="standbyEmail">
					<template #label>
						<label for="" class="font12 col8f padr14">邮箱号<em class="colred">*</em></label>
					</template>
					<el-input v-model="baseInfo.form.standbyEmail" placeholder="请输入邮箱号" class="w240"
						size="large"></el-input>
					<!-- <el-input v-model="param.mainContact" placeholder="请输入主要联系人" class="w240" size="large" ></el-input> -->
				</el-form-item>
				<el-form-item prop="spareMode">
					<template #label>
						<label for="" class="font12 col8f padr14">联系方式<em class="colred">*</em></label>
					</template>
					<el-radio-group v-model="baseInfo.form.spareMode">
						<el-radio :value="1" label="电子邮件" />
						<el-radio :value="2" label="电话" />
					</el-radio-group>
				</el-form-item>
			</template>
		</el-form>

		<div class="padb20 padt20" style="padding-left: 117px">
			<el-button class="w90" @click="step = 3" size="large">上一步</el-button>
			<el-button v-loading="subLoading" class="w90" type="primary" size="large" @click="submit">提交</el-button>
			<el-button class="w68" @click="celall" size="large">取消</el-button>
		</div>
	</div>
</template>
<script lang="jsx">
import OSS from 'ali-oss'
import {uploadOssGetToken} from "@/utils/api1.js"
import {shallowRef} from 'vue'
import {mapGetters, mapState} from 'vuex'
import '@wangeditor/editor/dist/css/style.css'
// import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
//图标
import {Back} from '@element-plus/icons-vue'

export default {
	components: {
		Back,
		//  Editor, Toolbar
	},
	computed: {
		...mapGetters({
			csiList: 'cache/getCsiList',
			hardwarePlatform: 'cache/getHardwarePlatform',
			language: 'cache/getLanguage',
			deploy: 'cache/getDeploy',
      urgencyDict: 'cache/getUrgency',
		}),
		...mapState({
			userInfo: state => state.userinfo
		}),
		moduleMapList() {
			return this.vselect.module.map_options.get(this.baseInfo.form.productId?.id)
		},
		versionMapList() {
			return this.vselect.version.map_options.get(this.baseInfo.form.productId?.id)
		},
		computed_moduleText() {
			const form = this.baseInfo.form
			return `${form.productName}/${form.versionName}/${form.moduleName}`
		},
		// 判断是否为特定场景
		isSpecificScenario() {
			// 首先获取当前选择的CSI信息
			const currentCsi = this.csiList.find(item => item.id == this.baseInfo.form.csi)
			// 检查是否为特定客户服务号且环境用途为生产环境
			const result = currentCsi &&
				['100002', '100003'].includes(currentCsi.csiNumber) &&
				this.baseInfo.form.environmentalUse === 1
			return result
		}
	},
	data() {
		const checkMobile = (rule, value, callback) => {
			if (!value) {
				callback(new Error("请输入手机号！"));
			} else if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(value)) {
				callback(new Error("当前输入号码有误，请核对后再次进行输入"));
			} else {
				callback();
			}
		};
		const checkEmail = (rule, value, callback) => {
			const reg = new RegExp("^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$"); //正则表达式
			if (!value) {
				callback(new Error("请输入邮箱号！"));
			} else if (!reg.test(value)) {
				callback(new Error("当前输入邮箱号有误，请核对后再次进行输入"));
			} else {
				callback();
			}
		};
		return {
			environmentalUseL: [
				{ value: 1, name: '生产环境' }, { value: 2, name: '测试环境' }, { value: 3, name: 'POC' },
				{ value: 4, name: '生态适配' }, { value: 5, name: '准生产' }, { value: 6, name: '其他' },
			],
			username: '',
			editorRef: shallowRef(),
			editorConfig: { placeholder: '请输入内容...' },
			step: 1,
			checkLoading: false,
			loading: false,
			subLoading: false,
			param: {
				problemDesImagePath: [], //图片地址
				attachmentPath: [],   //附件地址
				workOrderType: 2,
				problemSeverity: 3,
			},
			knowDoc: {
				_param: {},
				param: {
					docTitle: '',
					pageNumber: 1,
					pageSize: 10,
				},
				list: [],
				total: 0,
				loading: false
			},
			productName: {}, //产品名称item
			operationSystem: {}, //操作系统
			operationSystemVersion: {}, //操作系统->版本
			problemType: {}, //问题类型
			productNameVersion: null,
			rules: {
				mainContact: [{ required: true, message: '请输入主要联系人！', trigger: 'blur', },],
				mainEmail: [{ validator: checkEmail, trigger: 'blur' }],
				mainMobile: [{ validator: checkMobile, trigger: 'blur' }],
				contactWay: [{ required: true, message: '请选择联系方式！', trigger: 'change', },],
				standbyContact: [{ required: true, message: '请输入联系人！', trigger: 'blur', },],
				standbyMobile: [{ validator: checkMobile, trigger: 'blur' }],
				standbyEmail: [{ validator: checkEmail, trigger: 'blur' }],
			},



			// Added
			baseInfo: {
				isSubmit: true,
				form: {
					oneMachine: 2,
					type: 2,
					problemDescription: "",
					isOpen: 1,
					vs_conmode: 1,
					vs_sp_conmode: 1,
					vs_sp_conid: '',
					departmentId: [], u: 3,
					urgencyCode: '',
					mode: 1,
					spareMode: 1,
					// 初始化关键属性
					accountName: '',
					csi: undefined,
					environmentalUse: undefined,
				},
				rule: {
					occurrenceTime: [{ required: true, message: '请选择对业务影响开始时间！', trigger: 'change' }],
					accountName: [{ required: true, message: '请输入客户名称！', trigger: 'change' }],
					isEffect: [{ required: true, message: '请选择是否影响业务！', trigger: 'change' }],
					environmentalUse: [{ required: true, message: '请选择环境用途！', trigger: 'change' }],
					hardwarePlatform: [{ required: true, message: '请选择硬件平台！', trigger: 'change' }],
					operatingSystemVersionId: [{ required: true, message: '请选择操作系统版本', trigger: 'change' }],
					operatingSystemLanguage: [{ required: true, message: '请选择操作系统语言！', trigger: 'change' }],
					productId: [{ required: true, message: '请选择产品名称！', trigger: 'change' }],
					versionId: [{ required: true, message: '请选择产品版本！', trigger: 'change' }],
					productModuleId: [{ required: true, message: '请选择问题类型！', trigger: 'change' }],
					deploymentWay: [{ required: true, message: '请选择部署方式！', trigger: 'change' }],
					oneMachine: [{ required: true, message: '请选择是否一体！', trigger: 'change' }],
					csi: [
						{
							validator: (rule, value, callback) => {
								if (this.csiList.length) {
									return callback()
								}
								this.$message.warning('请前往账号中心绑定CSI号！')
								return callback(new Error('请前往账号中心绑定CSI号！'))
							}, trigger: 'focus'
						},
						{ required: true, message: '请选择csi号！', trigger: 'change' }
					],
					problemProfile: [{ required: true, message: '请输入问题概要！', trigger: 'blur' }],
					problemDescription: [{
						validator: (rule, value, callback) => {
							if (value) {
								return callback()
							}
							return callback(new Error('请输入问题描述！'))
						}
					}],
					isOpen: [{ required: true, message: '请选择是否公开！', trigger: 'change' }],
					u: [{
						validator: (rule, value, callback) => {
							if (value) {
								return callback()
							}
							this.$message.warning('请选择问题严重性！')
							return callback(new Error('请选择问题严重性！'))
						}, required: true, message: '请选择问题严重性！', trigger: 'change'
					}],
					urgencyCode: [{ required: true, message: '请选择紧急程度！', trigger: 'change' }],
					departmentId: [
						{
							validator: (rule, value, callback) => {
								if (value.length) {
									return callback()
								}
								return callback(new Error('请选择团队部门'))
							}, trigger: 'change'
						},
					],

					// 联系人校验
					mainContact: [{ required: true, message: '请输入联系人姓名！', trigger: 'blur' }],
					mainMobile: [
						{ validator: this.utils.checkMobile, required: true, trigger: 'blur' },
						{ required: true, message: '请输入手机号', trigger: 'blur' }
					],
					mainEmail: [

						{
							validator: (rule, value, callback) => {
								// console.log(value);
								const reg = new RegExp("^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$"); //正则表达式
								if (!value) {
									callback();
								} else if (!reg.test(value)) {
									callback(new Error("当前输入邮箱号有误，请核对后再次进行输入"));
								} else {
									callback();
								}
							}, required: true, trigger: 'blur'
						},
						{ required: true, message: '请输入邮箱', trigger: 'blur' }
					],
					mode: [
						{ required: true, message: '请选择方式', trigger: 'change' }
					],
					standbyContact: [{ required: true, message: '请输入联系人姓名！', trigger: 'blur' }],
					standbyMobile: [
						{ validator: this.utils.checkMobile, required: true, trigger: 'blur' },
						{ required: true, message: '请输入手机号', trigger: 'blur' }
					],
					standbyEmail: [
						{
							validator: (rule, value, callback) => {
								// console.log(value);
								const reg = new RegExp("^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$"); //正则表达式
								if (!value) {
									callback();
								} else if (!reg.test(value)) {
									callback(new Error("当前输入邮箱号有误，请核对后再次进行输入"));
								} else {
									callback();
								}
							}, required: true, trigger: 'blur'
						},
						{ required: true, message: '请输入邮箱', trigger: 'blur' }
					],
					spareMode: [{ required: true, message: '请选择联系方式', trigger: 'blur' }],
				}
			},
			system: {
				props: {
					checkStrictly: false,
					emitPath: true,
					value: 'id',
					label: 'title',
					children: 'list'
				},
				options: [],
			},
			vselect: {
				product: {
					loading: false,
					options: [],
					map_options: new Map()
				},
				module: {
					loading: false,
					map_options: new Map(),
					map_module_text: new Map(),
				},
				version: {
					loading: false,
					map_options: new Map()
				},
				team: {
					loading: false,
					map_options: new Map()
				},
				userContacts: {
					options: [], optionss: []
				}
			},
			fileList: {
				instance_attachmentPath: null,
				attachmentPath: [],
			}
		}
	},
	mounted() {
		// 并行加载数据，减少加载时间
		Promise.all([
			this.$store.dispatch('cache/getCsiList'),
			this.$store.dispatch('cache/getHardwarePlatformList'),
			this.$store.dispatch('cache/getLanguage'),
			this.$store.dispatch('cache/getDeploy'),
      this.$store.dispatch('cache/getUrgency'),
			this.operatingSystemList(),
		]).then(() => {
			// 初始化客户名称状态
			this.updateAccountNameStatus()
		})
	},
	beforeUnmount() {
		// this.editorRef.destroy()
	},
	methods: {
		handleTimeChange(e) {
			if(e){
				const occurrenceDate = new Date(this.baseInfo.form.occurrenceTime);
				const restoreDate = new Date(this.baseInfo.form.restoreTime);
				if(occurrenceDate&&restoreDate){
					const timeDifference = restoreDate - occurrenceDate;
					if (!isNaN(timeDifference)) {
						this.baseInfo.form.durationMalfunction = (Math.floor(timeDifference / (1000 * 60))>0)?Math.floor(timeDifference / (1000 * 60)):''
					} else {
						this.baseInfo.form.durationMalfunction = '';
					}
				}
			}else{
				this.baseInfo.form.durationMalfunction = ''
			}
		},
		base64Flie(base64, key1, key2, key3) {
			if (key3) {
				this[key1][key3][key2] += base64
			} else {
				this[key1][key2] += base64
			}
		},
		onContentChange(val, key1, key2, key3) {
			let that = this
			if (val.includes(';base64')) {
				let start = `<img src="data:`
				let end = `" alt="" />`
				const regex = new RegExp(`${start}(.*?)${end}`);
				const result = regex.exec(val);
				const substr = result ? ('data:' + result[1]) : "";
				uploadOssGetToken().then(res1 => {
					let p1 = ''
					val.split(substr)[0].split('<img src').map((e, i) => {
						if (i == 0) {
							p1 = p1 + e + '<img width="300px" src'
						} else if (i == val.split(substr)[0].split('<img src').length - 2) {
							p1 = p1 + e + '<img width="300px" src'
						} else {

						}

					})
					p1 = p1 + ' ="'
					if (res1) {
						that.uploadToOSS(res1, substr, key1, key2, key3, p1, val.split(substr)[1])
					}
				});
			} else if (key3) {
				this[key1][key3][key2] = val
			} else {
				this[key1][key2] = val
			}
		},
		async uploadToOSS(data, url, key1, key2, key3, p1, p2) {
			let that = this
			function dataURLtoBlob(dataurl) {
				const arr = dataurl.split(',');
				const mime = arr[0].match(/:(.*?);/)[1];
				const bstr = atob(arr[1]);
				let n = bstr.length;
				const u8arr = new Uint8Array(n);
				while (n--) {
					u8arr[n] = bstr.charCodeAt(n);
				}
				return new Blob([u8arr], { type: mime });
			}
			const blob = dataURLtoBlob(url)
			const date = new Date();
			const year = date.getFullYear();
			const month = (date.getMonth() + 1).toString().padStart(2, '0');
			const day = date.getDate().toString().padStart(2, '0');
			const filePath = `uploads${year}${month}${day}`;
			let file = new File([blob], filePath, { type: blob.type });
			let client = new OSS({
				region: 'oss-cn-beijing',
				secure: true,
				accessKeyId: data.ossAccessKeyId,
				accessKeySecret: data.accessKeySecret,
				stsToken: data.securityToken,
				endpoint: "oss-cn-beijing.aliyuncs.com",
				bucket: 'bucket-mvs'
			});
			try {
				//上传
				let result = await client.multipartUpload(Date.parse(new Date()) / 1000 + filePath, file, {});
				let url = result.res.requestUrls[0].split('?uploadId=')[0]
				if (key3) {
					that[key1][key3][key2] = p1 + url + p2
				} else {
					that[key1][key2] = p1 + url + p2
				}
				// that.file.url = result.res.requestUrls[0]
				// that.fileList.attachment['attachmentPath'] = result.res.requestUrls[0]
			} catch (e) {
				if (e.code === 'ConnectionTimeoutError') {
					content.onError('文件上传超时')
					throw "文件上传超时!";
				} else {
					content.onError('文件上传失败')
				}
			}
		},
		async vselect_team(id) {
			try {
				this.vselect.team.loading = true
				this.vselect.team.map_options.set(
					id,
					this.vselect.team.map_options.get(id) ?? (
						await this.$api.user.getDepartmentListByCsiId({
							id,
							pageNumber: 1,
							pageSize: 2000
						})
					).records
				)
				this.vselect.team.loading = false
			} catch (e) {
				this.vselect.team.loading = false
				this.vselect.team.options = []
			}
		},
		csiChange(e) {
			this.baseInfo.form.departmentId = [];
			//
			this.vselect.product.options = []
			this.baseInfo.form.productId = undefined
			this.baseInfo.form.versionId = undefined
			this.baseInfo.form.productModuleId = undefined
			//
			e && this.vselect_team(e);
			e && this.vselect_product(e)
			// 更新客户名称状态
			this.updateAccountNameStatus()
		},
		// 环境用途变更处理
		environmentalUseChange() {
			// 更新客户名称状态
			this.updateAccountNameStatus()
		},
		// 更新客户名称状态和值
		updateAccountNameStatus() {
			// 确保CSI列表数据可用且已选择CSI
			if (this.csiList && this.csiList.length > 0 && this.baseInfo.form.csi) {
				const currentCsi = this.csiList.find(item => item.id == this.baseInfo.form.csi)
				if (currentCsi) {
					// 根据场景更新客户名称
					if (this.isSpecificScenario) {
						// 特定场景：清空客户名称，设置为可编辑
						this.baseInfo.form.accountName = ''
					} else {
						// 通用场景：从CSI信息中提取公司名称，设置为禁用
						this.baseInfo.form.accountName = currentCsi.companyName
					}
					// 重新触发验证
					if (this.$refs['submitForm_baseInfo']) {
						this.$refs['submitForm_baseInfo'].validateField('accountName')
					}
				}
			}
		},
		csiClear() {
			this.baseInfo.form.departmentId = []
			this.baseInfo.form.accountName = ''
		},
		async vselect_product(csi) {
			try {
				this.vselect.product.loading = true
				const { records, total } = await this.$api.bug.productListByCsi({
					id: csi,
					type: this.baseInfo.form.type,
					pageNumber: 1,
					pageSize: 1500
				})
				this.vselect.product.map_options = new Map(
					records.map(item => [item.id, item])
				)
				this.vselect.product.options = records
				this.vselect.product.loading = false
			} catch (e) {
				this.vselect.product.loading = false
				this.vselect.product.options = []
			}
		},
		async vselect_version(id) {
			try {
				this.vselect.version.loading = true
				this.baseInfo.form.versionId = undefined
				this.baseInfo.form.productModuleId = undefined
				this.vselect.version.map_options.set(
					id,
					this.vselect.version.map_options.get(id) ?? (
						await this.$api.bug.versionList({
							productId: id,
							pageNumber: 1,
							pageSize: 2000
						})
					).records
				)
				this.vselect.version.loading = false
			} catch (e) {
				this.vselect.version.loading = false
				this.vselect.version.options = []
			}
		},
		productModuleIdChange(e) {
			if (e) {
				this.baseInfo.form.moduleName = e.map(item => this.vselect.module.map_module_text.get(item)).join('/')
				this.searchQuestionTemplate({
					productId: this.baseInfo.form.productId.id,
					productModuleId: e[e.length - 1]
				})
			}
		},
		async vselect_module(id) {
			try {
				this.vselect.module.loading = true
				this.baseInfo.form.versionId = undefined
				this.baseInfo.form.productModuleId = undefined

				this.vselect.module.map_options.set(
					id,
					this.vselect.module.map_options.get(id) ?? (
						await this.$api.bug.moduleList({
							id,
							pageNumber: 1,
							pageSize: 2000
						})
					).records
				)
				// 构建文字id映射
				this.vselect.module.map_options.get(id).map(item => {
					this.vselect.module.map_module_text.set(item.id, item.moduleName)
					item.moduleListDtos.map(item => {
						this.vselect.module.map_module_text.set(item.id, item.moduleName)
					})
				})
				this.vselect.module.loading = false
			} catch (e) {
				this.vselect.module.loading = false
				this.vselect.module.options = []
			}
		},
		async operatingSystemList() {
			try {
				const { records } = await this.$api.base.operatingSystemList({
					pageNumber: 1,
					pageSize: 2000
				})
				this.system.options = records
			} catch (e) {
				return console.log(e)
			}
		},

		celall() {
			this.$router.push('/tech/list/2')
			return
			this.$confirm('退出编辑后，您编辑的内容将会被清除请提前做好编辑内容的备份哦', '您确定要退出编辑当前的工单么？', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
			}).then(() => {
				// this.$router.go(-1)
				this.$router.push('/tech/list/2')
			}).catch(() => {

			});
		},
		async submitBaseStep() {
			try {
				await this.$refs['submitForm_baseInfo'].validate()
				this.checkLoading = true
				if (this.baseInfo.form.csi) {
					const { status } = await this.$api.order.checkProductReq({
						productId: this.baseInfo.form.productId.id,
						productModuleId: this.baseInfo.form.productModuleId[this.baseInfo.form.productModuleId.length - 1],
						versionId: this.baseInfo.form.versionId.id,
						csi: this.baseInfo.form.csi,
					})
					if (status == 0) {
						return this.$message.warning('该CSI编号暂未绑定当前提交工单的产品类型')
					}
				}
				this.knowDoc.param.docTitle = this.baseInfo.form.problemProfile
				this.getknowDocList()
				this.step = 2
			} catch (e) {

				return console.log(e)
			} finally {
				this.checkLoading = false
			}
		},
		async getknowDocList() {
			try {
				let param = JSON.parse(JSON.stringify(this.knowDoc.param))
				delete param.docTitle
				this.knowDoc.loading = true
				const { records, total } = await this.$api.know.getDocLists(param, { docTitle: this.knowDoc.param.docTitle })
				this.knowDoc.list = records
				this.knowDoc.total = total
			} catch (e) {
				return console.log(e)
			} finally {
				this.knowDoc.loading = false
			}
		},
		async submitAttachmentStep() {
			try {
				await this.$refs['submitForm_Attachment'].validate()
				this.step = 4
				// 获取常用联系人
				this.getUserContacts()
				this.getUserContactss()
			} catch (e) {
				return console.log(e)
			}
		},
		remoteMethod(e) {
			this.username = e
			this.getUserContacts()
		},
		async getUserContacts() {
			try {
				const result = await this.$api.order.getUserContacts({
					id: this.baseInfo.form.csi,
					username: this.username
				})
				this.vselect.userContacts.options = result
			} catch (e) {
				return console.log(e)
			} finally {

			}
		},
		remoteMethods(e) {
			this.usernames = e
			this.getUserContactss()
		},
		async getUserContactss() {
			try {
				const result = await this.$api.order.getUserContacts({
					id: this.baseInfo.form.csi,
					username: this.usernames
				})
				this.vselect.userContacts.optionss = result
			} catch (e) {
				return console.log(e)
			} finally {

			}
		},
		async submit() {
			try {
				await this.$refs['ruleForm'].validate()
				if (!this.subLoading) {
					this.subLoading = true
				} else {
					return this.$message.warning('请勿重复提交')
				}
				if (this.baseInfo.form.u == 1) {
					await this.$msgbox.alert(
						<div style="padding-bottom:20px">
							<p style="margin-top:20px">如果问题严重性选择的是U1-服务完全丢失 我们的技术支持需要您提供全天候联系人，以便根据需要随时请求其它信息</p>
							<p style="margin-bottom:10px">根据海量数据的技术支持策略，严重性为1级的应该满足一下标准：</p>
							<ul>
								<li> 您对受支持程序的使用被迫停止或受到严重影响, 以至于您无法适当地继续工作。</li>
								<li> 您遇到过服务完全丢失的情况。</li>
								<li> 持续操作受支持的程序对业务来说至关重要, 并且情况紧急。</li>
							</ul>
						</div>,
						'温馨提示',
					)
				}
				this.$confirm('工单提交后 平台对应的客服工程师将会为您解决对应的问题 请耐心等待', '您确定提交当前的工单么？', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
				}).then(res => {
					// debugger
					this.baseInfo.form.environmentalUse==1&&this.baseInfo.form.isEffect==1
					const _data = JSON.parse(JSON.stringify(this.baseInfo.form))
					delete _data.problemDescription
					delete _data.errorCode
					delete _data.problemProfile
					delete _data.vs_sp_conid
					delete _data.vs_conid
					if (_data.attachmentDescription) {
						delete _data.attachmentDescription
					}
					if(_data.environmentalUse==1&&_data.isEffect==1){}else{
						_data.occurrenceTime = ''
						_data.restoreTime = ''
						_data.durationMalfunction = ''
					}
					_data.productId = _data.productId.id
					_data.versionId = _data.versionId.id
					_data.productModuleId = _data.productModuleId[_data.productModuleId.length - 1]
					_data.operatingSystemId = _data.operatingSystemVersionId[0]
					_data.operatingSystemVersionId = _data.operatingSystemVersionId[1]
					_data.departmentId = _data.departmentId.join(',')
					_data.mode = _data.mode
					_data.spareMode = _data.spareMode
					console.log(_data)
					this.$api.order.subOrder(_data, {
						problemDescription: this.baseInfo.form.problemDescription,
						errorCode: this.baseInfo.form.errorCode,
						problemProfile: this.baseInfo.form.problemProfile,
						attachmentDescription: this.baseInfo.form.attachmentDescription,
					}).then(result => {
						if (result) {
							this.baseInfo.isSubmit = false
							this.subLoading = false
							this.$router.replace({
								name: 'serviceInfo',
								params: {
									id: result.id
								}
							})
							this.$message.success('提交成功')
						}
						this.subLoading = false
					})

				}).catch(res => {
					this.subLoading = false
					console.log(res, 'error')
				 })

			} catch (e) {
				return console.log(e)
			} finally { }
		},
		async searchQuestionTemplate(param) {
			try {
				const result = await this.$api.base.searchQuestionTemplate(param)
				this.baseInfo.form.problemDescription = result.content
			} catch (e) {
				return console.log(e)
			}
		},
	},
	beforeRouteLeave(to, form, next) {
		if (this.baseInfo.isSubmit) {
			this.$confirm('退出编辑后，您编辑的内容将会被清除请提前做好编辑内容的备份哦', '您确定要退出编辑当前的工单么？', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
			}).then(() => {
				next()
			}).catch(() => {
				next(false)
			});
		} else {
			next()
		}

	}
}
</script>
<style lang="scss" scoped>
.ul-stepb1 {
	.line {
		width: 55px;
		height: 1px;
		background-color: #e2e2e4;
		margin: 0 10px;
	}
}

.ul1 {
	display: flex;
	height: 66px;
	font-size: 17px;
	color: #808080;

	li {
		display: flex;
		align-items: center;

		.num {
			width: 26px;
			height: 26px;
			background: #fff;
			display: flex;
			justify-content: center;
			line-height: 26px;
			border-radius: 50%;
			font-size: 16px;
			margin-right: 12px;
		}
	}

	>.act {
		color: #ff6a00;

		.num {
			background: #ff6a00;
			color: #fff;
		}
	}
}

.bl-tipb1 {
	padding-left: 14px;
	position: relative;
	margin-bottom: 10px;

	&::before {
		content: "";
		display: block;
		width: 4px;
		height: 16px;
		background: #ff6a00;
		position: absolute;
		top: 50%;
		left: 0;
		margin-top: -8px;
	}
}

.ul-form {
	font-size: 0;

	li {
		display: inline-block;
		vertical-align: top;
		margin-right: 24px;
		margin-bottom: 12px;
	}

	//.con {
	//	margin: 0 20px 12px;
	//}

	.ty {
		float: left;
		min-width: 110px;
		font-size: 14px;
		color: #8f8f8f;
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
		line-height: 40px;
		text-align: right;
		margin-right: 24px;

		em {
			font-style: normal;
			padding-right: 4px;
			color: #e1504a;
		}
	}

	.right {
		overflow: hidden;
	}

	// 响应式布局
	@media (max-width: 768px) {
		li {
			display: block;
			margin-right: 0;
			width: 100%;
		}
	}

	.tips {
		font-size: 14px;
		color: #969799;
	}

	&.sty1 {
		li {
			display: block;
			width: auto;
		}

		.con {
			margin: 0 0 30px;
		}
	}
}

.v-radio-group {
	display: block;
}
.new_tips{
	display:inline-block;
	color:red;
  font-weight:bold;
	width:100%;
	line-height: 20px;
	font-size:16px;
	margin-top:-15px
}
</style>
